<template>
    <page back>
        <dictionaries-picker
            slot="headerExtra"
            type="language"
            size="small"
            v-model="language"
            :clearable="false"
        />
        <el-form
            ref="addForm"
            slot="body"
            label-width="10em"
            size="small"
            :model="formModel"
            :rules="formRules"
        >
            <el-card
                size="small"
                shadow="never"
                header="基本信息"
            >
                <el-form-item
                    v-if="formModel.parentId && language == 1"
                    prop="parentName"
                    :label="$t('pageKey452', '上级分类')"
                    label-width="11em"
                >
                    <el-input
                        v-model="formModel.parentName"
                        disabled
                    />
                </el-form-item>
                <el-form-item
                    prop="name"
                    :label="$t('pageKey462', '分类名称')"
                    label-width="11em"
                >
                    <el-input
                        v-model="formModel.name"
                    />
                </el-form-item>
                <el-form-item
                    prop="goodsCatImage"
                    :label="$t('pageKey464', '分类图片')"
                    label-width="11em"
                >
                    <upload
                        validate-md5
                        action="/rs/attachment/uploadFileLibrary"
                        :limit="1"
                        v-model="formModel.goodsCatImage"
                    />
                </el-form-item>
                <el-form-item
                    prop="orderNum"
                    :label="$t('pageKey11', '排序')"
                    label-width="11em"
                    v-if="language == 1"
                >
                    <el-input-number
                        controls-position="right"
                        :min="1"
                        v-model.number="formModel.orderNum"
                    />
                </el-form-item>
            </el-card>
        </el-form>

        <div class="ta-c pa-a">
            <el-button
                type="primary"
                size="small"
                @click="onConfirm"
            >
                保 存
            </el-button>
            <el-button
                size="small"
                @click="$router.back()"
            >
                返 回
            </el-button>
        </div>
    </page>
</template>

<script>
import { formModelInitMixin } from '@/mixin/languageStore';
import { GlobalVar } from '@vmf/shared';

export default {
    name: 'GoodsCatEdit',
    mixins: [formModelInitMixin],
    data() {
        return {
            formModel: {
                id: '',
                parentId: '',
                parentName: '',
                name: '',
                goodsCatImage: [],
                orderNum: 1,
                isAvailable: '',
            },
            formRules: {
                name: [
                    {
                        required: true,
                        message: this.$t('pageKey463', '请输入分类名称'),
                        trigger: 'blur',
                    },
                    {
                        validator: this.validatorName,
                        message: this.$t('pageKey408', '分类名称不能重复'),
                        trigger: 'blur',
                    },
                ],
            },
            // 多语言配置
            languageTableName: 't_sp_shop_goods_cat',
            ignoreFieldCodes: ['id', 'parentId', 'parentName', 'orderNum', 'isAvailable'],
        };
    },
    methods: {
        onConfirm() {
            const { addForm } = this.$refs;
            addForm.validate().then(() => {
                this.$api.Sp.ShopGoodsCat.save({
                    ...this.getSaveData(1),
                }).then(json => {
                    const res = json.data;
                    this.saveLanguage(res.data.id);
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.$router.back();
                });
            });
        },
        init() {
            this.$api.Sp.ShopGoodsCat.getDetail({
                id: this.formModel.id,
            }).then(json => {
                const res = json.data.data;
                this.$utils.formModelMerge(this.formModel, this.buildInitData(res));
                this.updateLanguage(1, this.formModel);
            });
        },
        /* -- 自定义校验 -- */
        validatorName(rule, value, callback) {
            this.$api.Sp.ShopGoodsCat.exists({
                pId: this.formModel.parentId,
                id: this.formModel.id,
                name: this.formModel.name,
            }).then(res => {
                if (res.data.data) {
                    callback(rule.message);
                } else {
                    callback();
                }
            });
        },
        buildSaveData(item) {
            item.goodsCatImage = item.goodsCatImage
                ? item.goodsCatImage
                      .reduce((prev, curr) => {
                          prev.push(curr.name);
                          return prev;
                      }, [])
                      .join(',')
                : '';
            return item;
        },
        buildInitData(item) {
            const { goodsCatImage } = item;
            if (!goodsCatImage) {
                item.goodsCatImage = [];
            } else {
                item.goodsCatImage = goodsCatImage.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return item;
        },
    },
    created() {
        if (this.$route.params.id != -1) {
            this.formModel.id = this.$route.params.id;
        }
        this.formModel.parentId = this.$route.params.parentId;
        if (this.formModel.id) {
            this.init();
        }
    },
};
</script>

<style lang="scss">
</style>
